import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  serviceHealth,
  shrinkFile,
  validateFile,
} from '../../../../utils/fileUtils';
import FileUploaderEntries from './FileUploaderEntries';

const FileUploader = (props) => {
  const [isServiceUp, setServiceUp] = useState(false);
  const [depletedService, setDepletedService] = useState(false);

  const handleFileInput = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    const name = file.name;

    const error = validateFile(file, name);
    if (error) {
      props.onFileSelectError({ error: error });
      e.target.value = null;
      return;
    }

    props.setUploading(true);
    try {
      const compressedFile = await shrinkFile(file, name);
      if (compressedFile) {
        props.onFileSelectSuccess(compressedFile);
      } else {
        setDepletedService(true);
      }
    } catch (err) {
      toast.error(err.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    e.target.value = null;
    props.setUploading(false);
  };

  const getService = async () => {
    const serviceStatus = await serviceHealth();
    if (serviceStatus) setServiceUp(true);
  };

  useEffect(() => {
    getService();
  }, []);

  return (
    <div className="relative flex-grow w-full">
      <FileUploaderEntries
        isServiceUp={isServiceUp}
        depletedService={depletedService}
        handleFileInput={handleFileInput}
        getService={getService}
        isUploading={props.isUploading}
      />
    </div>
  );
};

export default FileUploader;
